import React, { useState, useEffect } from 'react'
import { Button, CircularProgress, Grid, makeStyles, TextField, Theme } from '@material-ui/core'
import { Delete } from '@material-ui/icons';
import { AttachmentRounded } from '@material-ui/icons'
import { uploadMultipleFilesMobileToBucket1 } from './uploader';
import { FileAttachment } from '@tuqqi/common';
import { SetCaptcher } from '../../Main';

interface IAttachment {
    policy: string,
    signature: string,
    attachments: any[]
    required: boolean
    showRequired?: boolean
    getUploadFiles: (fileData: []) => void;
    removeUploadFile: (fileDataKey: string) => void;
    id?: string
}

const styles = (theme: Theme) => ({
    iconContainer: {
        width: '100%',
    },
    buttonDropHolder: {
        width: '100%',
        height: 100,
        borderWidth: 1,
        borderColor: 'grey',
        borderStyle: 'dashed',
        borderRadius: 6,
        background: 'rgba(0, 0, 0, 0.05)',
    },
    buttonDropHolderRequired: {
        borderColor: '#d32f2f',
    },
    inputFile: {
        width: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.12)',
    },
    uploadedFile: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '10px 5px',
        marginBottom: 10,
        borderRadius: 4,
        background: 'rgba(0, 0, 0, 0.12)',
        borderWidth: '1px',
        borderColor: 'rgba(0, 0, 0, 0.12)',
        borderStyle: 'solid',
    },
    hiddenReq: {
        height: 1,
        width: 1,
        marginRight: 'auto',
        marginLeft: '50%',
        display: 'flex',
        opacity: 0,
    },
    deleteFileIcon: {
        cursor: 'pointer',
    }
})

const useStyles = makeStyles(styles)

export default function RenderAttachment({ id, showRequired, policy, signature, getUploadFiles, removeUploadFile, attachments, required }: IAttachment) {
    const classes = useStyles();

    const [isUploading, setIsUploading] = useState<boolean>(false);
    const [pickedFiles, setPickedFiles] = useState<any>([]);

    const onSuccess = (attachments: FileAttachment[]) => {
        const att = attachments.map(x => ({
            ...x,
            filename: x.fileName,
            key: x.fileUid
        }))
        //@ts-ignore
        getUploadFiles(att)
    }

    const onError = () => {

    }

    const fileUploadHandler = async (_files: FileList | null) => {
        const files = Array.from(_files ?? []).map(first => ({
            fileName: first.name,
            fileSize: first.size,
            fileType: first.type,
            uri: URL.createObjectURL(first)
        }))
        setIsUploading(true);
        const abortController = new AbortController();

        try {
            const captcha = await window.grecaptcha.execute("6LdZrBwcAAAAAOxKnSN_re2ZO6tkIJ-uM0Tej5kF", { action: "homepage" })
            SetCaptcher.cb(captcha)
            await uploadMultipleFilesMobileToBucket1(captcha)(
                files,
                abortController,
                onSuccess,
                onError
            );
        } catch (err) {
        } finally {
            setIsUploading(false);
        }
    }

    const selectFiles = (e: React.ChangeEvent<HTMLInputElement>) => {
        const files = e.target.files;
        fileUploadHandler(files)
    }

    const handleDrop = (e: any) => {
        e.preventDefault();
        e.stopPropagation();

        const files = e.dataTransfer.files;

        fileUploadHandler(files);
    }

    const handleDragEnter = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
    }

    const handleDragOver = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
    }


    const handleDragLeave = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
    }

    const onDeleteFile = (key: string, pickedFiles: []) => {
        removeUploadFile(key)
    }

    useEffect(() => {
        const x = attachments.filter(x => !x?.key?.includes?.("signature-image-temp.png"))
        setPickedFiles(x)
    }, [attachments])


    const Req =  required && !pickedFiles.length ? <TextField className={classes.hiddenReq} required style={{}} /> : null

    return <Grid container direction='row' wrap='nowrap'>
        <Grid item className={classes.iconContainer}>
            
            {pickedFiles.length ? pickedFiles.map((item: any) => (
                <div key={item.key} className={classes.uploadedFile}>
                    <span>{item.filename}</span>
                    <Delete
                        className={classes.deleteFileIcon}
                        onClick={(e: React.MouseEvent<SVGSVGElement>) => onDeleteFile(item.key, pickedFiles)}
                    />
                </div>
            )) : null}
            <Grid container 
                direction='column'  
                justifyContent="center"
                alignItems="center"className={`${classes.buttonDropHolder} ${showRequired ? classes.buttonDropHolderRequired : ''}`}              
                onDrop={handleDrop}
                onDragEnter={handleDragEnter}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                >
                <label htmlFor={id ?? "btn-upload"}>
                    <input
                        id={id ?? "btn-upload"}
                        name={id ?? "btn-upload"}
                        style={{ display: 'none' }}
                        type="file"
                        multiple
                        onChange={selectFiles}
                    />
                    {Req}
                    {!isUploading ? <Button
                        className={classes.inputFile}
                        variant="outlined"
                        startIcon={<AttachmentRounded />}
                        component="span" >
                        Drag and Drop Your Files Or Browse
                    </Button>
                    :<CircularProgress size={30} />
                    }
                </label>
            </Grid>
        </Grid>
    </Grid>
}